import { RESOURCE } from '@src/constants';
import api from './api';

const getListTTSPreset = async () => {
  const response = await api({
    method: 'GET',
    url: RESOURCE.TTS_PRESET,
  });
  return response;
};

const deleteTTSPreset = async (id) => {
  const response = await api({
    method: 'DELETE',
    url: `${RESOURCE.TTS_PRESET}/${id}`,
  });
  return response;
};

const createTTSPreset = async (data) => {
  const response = await api({
    method: 'POST',
    url: RESOURCE.TTS_PRESET,
    data,
  });
  return response;
};

const updateTTSPreset = async (id, data) => {
  const response = await api({
    method: 'PUT',
    url: `${RESOURCE.TTS_PRESET}/${id}`,
    data,
  });
  return response;
};

export { getListTTSPreset, deleteTTSPreset, createTTSPreset, updateTTSPreset };
